/*
 * Copyright Huesik (c) 2019.
 */

// import Vuex from 'vuex'
const store = {
  RANKING_LIST: {
    IS_HIDE: false
  },
  SEARCH: {
    KOSIWON_LIST: [],
    HOVER_KOSIWON: undefined,
    OPEN_STATUS: ''
  },
  MAPS: {
    BOUND_DISTANCE: undefined,
    MAP: undefined,
    CENTER: {
      LATITUDE: undefined,
      LONGITUDE: undefined
    },
    BOUNDS: {
      SW: undefined,
      NE: undefined
    }
  },
  FILTERS: {
    MONEY_RANGE: [0, 120],
    USE_SEX_TYPE: [],
    OPTIONAL_FILTER: {
      is_elevator: 0,
      is_parking : 0,
      is_cctv : 0,
      option_doorlock : 0,
      option_refrigerator : 0,
      option_tv : 0,
      option_internet : 0,
      option_aircon : 0,
      option_wash : 0,
      is_dry : 0,
      is_sprinkler: 0,
      is_double_room: 0
    },
    ROOM_TYPE: []
  },
  USERS: {
    ACCESS_TOKEN: undefined,
    REFRESH_TOKEN: undefined
  },
  INTEREST: {
    PICK_LIST: [],
    LAST_VIEW_LIST: []
  },
  NETWORK: {
    SHOW_INDICATOR: false
  },
  APP: {
    IS_NATIVE: false,
    FIRST_LOADING: true
  }
}

export default store
